import { StateSchema } from 'app/config/storeConfig/types';

export const getShowGrid = (state: StateSchema): boolean => state.warehouseMapConstructor.showGrid;
